(() => {
	const GROUP = "[data-product-sibling-group]";
	const TRIGGER = `${GROUP} a[interestfor]`;

	const supportsInterestInvoker = Object.hasOwn(
		HTMLButtonElement.prototype,
		"interestForElement"
	);

	if (supportsInterestInvoker) return;

	const getPopover = (link) => {
		const id = link.getAttribute("interestfor");
		return id ? document.getElementById(id) : null;
	};

	document.addEventListener("mouseover", (event) => {
		const link = event.target.closest(TRIGGER);
		if (!link) return;

		const popover = getPopover(link);
		if (!popover?.showPopover || popover.matches(":popover-open")) return;

		try {
			popover.showPopover({ source: link });
		} catch {
			popover.showPopover();
		}
	});

	document.addEventListener("mouseout", (event) => {
		const link = event.target.closest(TRIGGER);
		if (!link) return;
		if (event.relatedTarget && link.contains(event.relatedTarget)) return;

		getPopover(link)?.hidePopover?.();
	});
})();
